import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import Button from "../../Elements/Button";
import useToastNotify from "../../../hook/useToastNotify";
import InputSelect from "../../Elements/Form/InputSelect";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import {ITeacherAttachmentData, ITeacherSocialNetworkData} from "../../../contracts/data/teacher";
import {TeacherAttachmentType, TeacherSocialNetworkType} from "../../../constans/enumTypes";
import {
    generateImageLink, generateMediaLink,
    generateTeacherAttachmentTitle,
    generateTeacherSocialNetworkTitle, isNotEmpty
} from "../../../helpers/functions";
import InputFile from "../../Elements/Form/InputFile";


const InnerTeacherAttachmentForm = (props: FormikProps<ITeacherAttachmentData>) => {
    const {toastNotify} = useToastNotify()
    const options:Array<ISelectOptionsItem> = [
        {value: TeacherAttachmentType.FILE, label:generateTeacherAttachmentTitle(TeacherAttachmentType.FILE)},
        {value: TeacherAttachmentType.IMAGE, label:generateTeacherAttachmentTitle(TeacherAttachmentType.IMAGE)},
    ]

    useEffect(() => {
        if (props?.status?.hasOwnProperty('result')) {
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return (
        <React.Fragment>
            <Form className={"my-6"}>
                <div className={"w-full"}>
                    <InputSelect name={'type'} label={'نوع فایل'}
                                 placeholder={'نوع فایل..'}
                                 handleSetValue={(values: any) => props.setFieldValue('type', values)}
                                 options={options} isMultiple={false} error={props?.errors?.type} // props?.errors?.type!
                                 meta={props.getFieldMeta('type')}
                                 defaultValue={options.find((item, _) => item.value === props?.values?.type)}
                                 isRequired
                    />
                    <InputFile name={"attachment"} accept={".jpg,.jpeg,.png,.zip,.pdf,.rar"} label={"فایل"}
                               meta={props.getFieldMeta('attachment')} isImg={props?.values?.type === TeacherAttachmentType.IMAGE} handleUploadFile={props.setFieldValue}
                               defaultValue={props.values?.attachment} isRequired
                    />
                </div>
                <div className={"text-right"}>
                    <Button title={props.status?.formType === 'create' ? "ثبت اطلاعات جدید" : "بروزرسانی اطلاعات"}
                            isLoading={props.isSubmitting}/>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default InnerTeacherAttachmentForm